import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";

const deviceId = localStorage.getItem("deviceId") || uuid();

export const trainerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllTrainers: builder.query({
      query: () => {
        return {
          url: "/trainer",
          method: "GET",
        };
      },
    }),

    // GET ALL WITH PAGINATION
    getAllTrainerWithPagination: builder.query({
      providesTags: ["trainer"],
      query: (body) => {
        return {
          url: "/trainer",
          method: "POST",
          body
        };
      },
    }),

    // Add
    addTrainer: builder.mutation({
      invalidatesTags: ["trainer"],
      query: (body) => {
        return {
          url: "/trainer/add",
          method: "POST",
          body,
        };
      },
    }),

    // EDIT
    editTrainer: builder.mutation({
      invalidatesTags: ["trainer"],
      query: ({ body, id }: any) => {
        return {
          url: `/trainer/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    //Single View
    viewTrainerById: builder.query({
      providesTags: ["trainer"],
      query: (id: any) => {
        return {
          url: `/trainer/${id}`,
          method: "GET",
        };
      },
    }),

    // Delete
    deleteTrainer: builder.mutation({
      invalidatesTags: ["trainer"],
      query: (id: string) => {
        return {
          url: `/trainer/${id}`,
          method: "DELETE",
        };
      },
    }),
     //Update Trainer Password
     ChangeTrainerPassword: builder.mutation({
      invalidatesTags: ["trainer"],
      query: ({body,id}:any) => {
        return {
          url: `/trainer/${id}/update-password`,
          method: "PUT",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),

  }),
});

export const {
  useGetAllTrainersQuery,
  useGetAllTrainerWithPaginationQuery,
  useAddTrainerMutation,
  useEditTrainerMutation,
  useViewTrainerByIdQuery,
  useDeleteTrainerMutation,
  useChangeTrainerPasswordMutation
} = trainerApi;
